import React, { FC, Fragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';

import { ValidatedCheckbox } from 'components';
import { useCurrentUser } from 'hooks';

import { hasContributorPrivilege } from '../../helpers';
import {
  BodyTextField,
  BrandedCheckbox,
  UrlField,
  UrlPreview,
  ShareableCheckbox,
  ReadOnlyWarning,
} from '../';
import { usePostContext } from '../../PostContext';

const useStyles = makeStyles(theme => ({
  actions: {
    marginTop: theme.spacing(),
  },
}));

const LinkForm: FC = () => {
  const classes = useStyles();
  const currentUser = useCurrentUser();
  const { state } = usePostContext();
  const { t } = useTranslation();

  const hasContributorWidgets = hasContributorPrivilege(currentUser, state.moderatorMode);

  return (
    <Fragment>
      <BodyTextField />
      <UrlField />

      {state.validUrl && <UrlPreview />}

      <div className={classes.actions}>
        <ShareableCheckbox />
        <BrandedCheckbox />
        {state.engagePost && hasContributorWidgets && (
          <ValidatedCheckbox name="is_engageable" label={t('posting:engageable')} color="primary" />
        )}
        <ReadOnlyWarning />
      </div>
    </Fragment>
  );
};

export default LinkForm;
